import lang from "src/assets/lang.json";
import iso from "src/assets/iso.json";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { Router } from "@angular/router";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import {
  ListCatalogContent,
} from "src/app/core/services/outbound";
import {
  user_role_color_map,
  user_role_map,
  user_search_placeholder_map,
  user_status_color_map,
  user_status_map,
} from "src/app/core/services/constants";

@Component({
  selector: "app-catalogs-selector",
  templateUrl: "./catalogs-selector.component.html",
  styleUrls: ["./catalogs-selector.component.scss"],
  providers: [],
})

/**
 * Contacts domain-list component
 */
export class CatalogsSelectorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedCollections = [];
  @Input() className: string[];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  // bread crumb items
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 24;
  currentPage = 0;
  collectionsList: {};
  collectionListSubscription: any;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  status_map = {};
  status_color_map = {};
  user_search_placeholder_map = {};
  user_role_map = {};
  user_role_color_map = {};
  payload = {};
  collectionListForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  countries = [];
  loading = false;
  verifySubscription: any;
  my_id: any;
  selectedCollectionsList = {};

  constructor(
    private ws: WebsocketService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // console.log(this.router.url);
    this.countries = iso.map((a) => a.name);
    this.status_map = user_status_map;
    this.status_color_map = user_status_color_map;
    this.user_role_map = user_role_map;
    this.user_role_color_map = user_role_color_map;
    this.user_search_placeholder_map = user_search_placeholder_map;

    // console.log(this.countries);
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.collectionsList = {};
    // console.log(Object.keys(this.userList).length);

    this.collectionListForm = this.formBuilder.group({
      chat_id: new UntypedFormControl(null),
      created_date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
      search_value: new UntypedFormControl(null),
      category: new UntypedFormControl(""),
    });

    this.collectionListSubscription =
      this.ws.listCatalogContainer$.subscribe((listCollectionsData) => {
        if (
          listCollectionsData &&
          listCollectionsData.ref === this.component_ref
        ) {
          this.loading = false;
          this.currentPage = listCollectionsData.page_number;
          if (listCollectionsData.data.length == 0 && this.currentPage == 1) {
            this.search_message = "No results matched your search criteria";
          }

          listCollectionsData.data.forEach((collection: any) => {
            collection.created_date = new Date(collection.created_date);
            collection.created_date =
              collection.created_date.getDate() +
              " " +
              this.monthNames[collection.created_date.getMonth()] +
              ", " +
              collection.created_date.getFullYear();

            this.collectionsList[String(collection.id)] = collection;
          });
          this.page = [];
          for (let i = 0; i < this.pageSize; i++) {
            if (
              Object.keys(this.collectionsList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ) {
              this.page.push(
                this.collectionsList[
                  Object.keys(this.collectionsList)[
                    i + (this.currentPage - 1) * this.pageSize
                  ]
                ]
              );
            }
          }

          document.getElementById("pagination_back").classList.remove("d-none");
          document
            .getElementById("pagination_back")
            .classList.add("enablePointer");
          document.getElementById("pagination_next").classList.remove("d-none");
          document
            .getElementById("pagination_next")
            .classList.add("enablePointer");

          this.eop = false;
          if (listCollectionsData.eop) {
            this.eop = true;
            document.getElementById("pagination_next").classList.add("d-none");
            document
              .getElementById("pagination_next")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_next")
              .classList.remove("d-none");
            document
              .getElementById("pagination_next")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1) {
            document.getElementById("pagination_back").classList.add("d-none");
            document
              .getElementById("pagination_back")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_back")
              .classList.remove("d-none");
            document
              .getElementById("pagination_back")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1 && listCollectionsData.eop) {
            document
              .getElementById("showPageNumber")
              .classList.add("invisible");
          } else {
            document
              .getElementById("showPageNumber")
              .classList.remove("invisible");
          }
          this.ref.detectChanges();
        }
      });

    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          this.payload["category"] = this.className;
          this.my_id = this.mdw.getID();
          this.loading = true;
          this.ws.processMethod(
            new ListCatalogContent(0, this.pageSize, this.component_ref)
          );
        }
      }
    );

    if (this.selectedCollections && this.selectedCollections.length > 0) {
      for (let i = 0; this.selectedCollections.length > i; i++) {
        this.selectedCollectionsList[this.selectedCollections[i].id] =
          this.selectedCollections[i];
      }
    }

    this.breadCrumbItems = [
      { label: "MENUITEMS.STOREMANGER.TEXT" },
      { label: "COLLECTIONS.COLLECTIONS", active: true },
    ];
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.collectionListSubscription) {
      this.collectionListSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    document.getElementById("pagination_back").classList.add("d-none");
    document
      .getElementById("pagination_back")
      .classList.remove("enablePointer");
    document.getElementById("pagination_next").classList.add("d-none");
    document
      .getElementById("pagination_next")
      .classList.remove("enablePointer");
  }

  openDetails(data: any) {
    this.router.navigate([
      "/" +
        data.account_id +
        "/" +
        data.ref_domain +
        "/" +
        data.service.product,
    ]);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.collectionListForm.controls;
  }

  onSubmit() {
    this.loading = true;

    let id =
      this.f.search_type.value === "catalog"
        ? this.f.search_value.value
        : null;
    let name =
      this.f.search_type.value === "name" ? this.f.search_value.value : null;
    let created_date = this.f.created_date.value;
    let category = this.f.category.value;
    this.search(id, name, created_date, category);
  }

  search(id: any, name: any, created_date: any, category: string) {
    this.currentPage = 0;
    this.collectionsList = {};
    this.payload = {};
    this.search_message = "";

    this.payload = {
      page_size: this.pageSize,
      page_number: 0,
      chat_id: localStorage.getItem("chat_id"),
    };

    if (id != null && id !== "") {
      this.payload["catalog_id"] = id;
    }
    if (name != null && name !== "") {
      this.payload["name"] = name;
    }
    if (created_date != null && created_date !== "") {
      this.payload["created_date"] = created_date;
    }
    if (category != null && category !== "") {
      this.payload["category"] = [category];
    }else{
      this.payload["category"] = ["product", "digital"];
    }

    this.ws.processMethod(
      new ListCatalogContent(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["name"],
        this.payload["catalog_id"],
        this.payload["created_date"]
      )
    );
  }
  resetSearch() {
    this.currentPage = 0;
    this.collectionsList = {};
    this.search_message = "";

    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["app_id"] = localStorage.getItem("app_id");

    this.ws.processMethod(
      new ListCatalogContent(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["name"],
        this.payload["catalog_id"],
        this.payload["created_date"]
      )
    );
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["app_id"] = localStorage.getItem("app_id");

    this.ws.processMethod(
      new ListCatalogContent(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["name"],
        this.payload["catalog_id"],
        this.payload["created_date"],
      )
    );
  }
  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.collectionsList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.collectionsList[
              Object.keys(this.collectionsList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.collectionsList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  abbreviateNumber(value: any) {
    var newValue = value;
    if (value >= 1000) {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue: any;
      for (var precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat(
          (suffixNum != 0
            ? value / Math.pow(1000, suffixNum)
            : value
          ).toPrecision(precision)
        );
        var dotLessShortValue = (shortValue + "").replace(
          /[^a-zA-Z 0-9]+/g,
          ""
        );
        if (dotLessShortValue.length <= 2) {
          break;
        }
      }
      if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  getCountryName(alpha: string) {
    return iso.find((e) => e.alpha === alpha)?.name;
  }

  getPercent(frac: number) {
    return (frac * 100).toFixed(2).replace(/[.,]00$/, "") + "%";
  }

  getLangName(code: string) {
    return lang.find((e) => e.code === code)?.native;
  }

  checkUncheckAll(ev: any) {}

  openForm() {
    this.router.navigate(["/collections/new"]);
  }

  editCollection(data) {
    if (this.single) {
      if (this.selectedCollectionsList[data.id]) {
        delete this.selectedCollectionsList[data.id];
      } else {
        this.selectedCollectionsList = {};
        this.selectedCollectionsList[data.id] = data;
      }
    } else {
      if (this.selectedCollectionsList[data.id]) {
        delete this.selectedCollectionsList[data.id];
      } else {
        this.selectedCollectionsList[data.id] = data;
      }
    }
  }

  insertEvent() {
    const selected = Object.values(this.selectedCollectionsList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedCollectionsList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedCollectionsList[id] ? true : false;
  }
}
